import React, { useState, useEffect } from 'react';
import Loader from '../Loader';

const CompanySummary = (props) => {
    const [loading, setLoading] = useState(true);
    const [rowData, setRowData] = useState([]);

    useEffect(() => {
        setTimeout(() => {
            fetch('/api/company/usersummary').then(result => result.json()).then(rowData => {
                setRowData(rowData);
                setLoading(false);
            })
        }, 3000)
    }, [loading]);

    return (
        <div className="card">
            <h5 className="card-header py-3"><i className="fa fa-desktop" aria-hidden="true"></i> Company summary</h5>
            <div className="card-body" style={{ height: "75vh" }}>
                {
                    loading ? (<Loader />) : (
                        <div style={{ overflowY: "auto", overflowX: "hidden", height: "100%" }}>
                            {rowData.map(c =>
                                <div key={c.name} style={{ backgroundColor: "#f0f1f2", margin: "0px 2px 5px 0px", padding: "10px", borderRadius: "5px" }}>
                                    <span>{c.name}</span>
                                    <span> ({c.totalUser} users)</span>
                                </div>
                            )}
                        </div>
                    )
                }
            </div>
        </div>
    );
};

export default CompanySummary;
